const honorifics = [
  'Mr',
  'Ms',
  'Mrs',
  'Miss',
  'Dr',
  'Sir',
  'Dame',
  'Lord',
  'Lady',
  'Prof',
  'Hon',
] as const;

export const honorificsDropdownList = honorifics.map((honorific) => ({
  value: honorific,
  label: honorific,
}));
